(function() {
  // A shopper who tries three different sizes is telling you something. This
  // watches for that and offers the size recommender — the same panel the
  // "Not sure about your size?" button opens, opened by clicking that very
  // button, so there is one way in and no second copy of its behaviour here.
  //
  // Atelier Alpino (owner, 04/10, as in the design): the offer is a line under
  // the sizes (snippets/size-suggestions.liquid), not a dialog. The product
  // section re-renders on every variant change and brings back a fresh copy of
  // that line, so it is shown by a class on <html> (assets/size-help-nudge.css)
  // rather than by unhiding one node: whichever copy is in the page shows.
  var SIZE_LEGEND = /taglia|taglie|size|misura|numero/i;
  var DISTINCT_SIZES_NEEDED = 3;
  var SHOWN = 'sks-size-nudge-on';
  var ENTER = 'sks-size-nudge-enter';

  var chosen = [];
  var recommenderSeen = false;

  // The key carries a version because the first release of this recorded its
  // offer against a dialog the shopper never saw. Those sessions would
  // otherwise stay silenced by a promise that was not kept.
  function storageKey() {
    return 'sks-size-help:2:' + window.location.pathname;
  }

  // Once per product per session. The offer is worth making; making it again
  // to someone who has already said no is just an obstacle between them and
  // the size they were choosing.
  function alreadyOffered() {
    try {
      return window.sessionStorage.getItem(storageKey()) === '1';
    } catch (error) {
      return false;
    }
  }

  function rememberOffered() {
    try {
      window.sessionStorage.setItem(storageKey(), '1');
    } catch (error) {
      /* Private browsing, blocked storage: offer it again rather than not at all. */
    }
  }

  // The recommender's own trigger, and only while it is on screen: the app
  // reveals it after checking whether this product has a chart at all, so on a
  // product without one there is nothing to offer and nothing to open.
  function helpButton() {
    var button = document.getElementById('sz-btn');
    if (!button) return null;

    var shown = document.documentElement.classList.contains(SHOWN);
    var rect = button.getBoundingClientRect();
    if (!shown && (rect.width <= 0 || rect.height <= 0)) return null;
    if (shown && button.style.display === 'none') return null;

    recommenderSeen = true;
    return button;
  }

  function normalize(text) {
    return String(text || '')
      .split('\n')[0]
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  // Which group of options is the size. Named by its legend where there is one;
  // otherwise a single group of options on a product is the size by default,
  // and where there are several unnamed ones the guess is not worth making —
  // counting a shopper's colour changes as size doubt would offer help to
  // somebody who is not lost.
  function sizeFieldset() {
    var sets = Array.prototype.slice
      .call(document.querySelectorAll('variant-picker fieldset, .variant-picker fieldset'))
      .filter(function(fieldset) {
        return !fieldset.closest('.zrx-sticky-atc-bar, product-sticky-bar');
      });

    var named = sets.filter(function(fieldset) {
      var legend = fieldset.querySelector('legend');
      return SIZE_LEGEND.test(legend ? legend.textContent : '');
    });

    if (named.length) return named[0];
    return sets.length === 1 ? sets[0] : null;
  }

  function labelFor(input) {
    var label = null;

    if (input.id) {
      label = document.querySelector('label[for="' + input.id.replace(/["\\]/g, '\\$&') + '"]');
    }
    if (!label && input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL') {
      label = input.nextElementSibling;
    }

    return normalize(label ? label.textContent : input.value);
  }

  function sizeFromChange(target) {
    if (!target || !target.matches) return '';

    // the sticky bar's menu (Prestige's product-sticky-bar, or the app's before it)
    if (target.matches('.zrx-sticky-atc-select, product-sticky-bar select')) {
      var option = target.options ? target.options[target.selectedIndex] : null;
      return option ? normalize(option.textContent) : '';
    }

    if (target.matches('input[data-option-position]')) {
      if (target.closest('.zrx-sticky-atc-bar, product-sticky-bar')) return '';

      var fieldset = sizeFieldset();
      if (!fieldset || !fieldset.contains(target)) return '';

      return labelFor(target);
    }

    return '';
  }

  function distinctCount(list) {
    return list.filter(function(size, index) {
      return list.indexOf(size) === index;
    }).length;
  }

  function record(size) {
    if (!size) return;
    // The picker and the sticky bar are kept in step with each other, so one
    // tap raises a change event on both. The second carries the size the first
    // just set, and a size that is already the current one is not a choice.
    if (chosen[chosen.length - 1] === size) return;

    chosen.push(size);
    if (distinctCount(chosen) >= DISTINCT_SIZES_NEEDED) offer();
  }

  function show() {
    var root = document.documentElement;
    root.classList.add(SHOWN, ENTER);
    window.setTimeout(function() { root.classList.remove(ENTER); }, 480);
  }

  function hide() {
    document.documentElement.classList.remove(SHOWN, ENTER);
  }

  // A re-render is in flight while the shopper is still tapping, and it takes
  // the recommender's button with it: the markup comes back from the server
  // hidden, and the app reveals it again once it has re-checked the product.
  // Offering during that gap would put a call to action on screen with nothing
  // behind it, so it waits for the button rather than firing blind — and gives
  // up if it never comes back, which is what a product with no chart looks like.
  var WAIT_FOR_BUTTON_MS = 2000;
  var waiting = false;

  function offer() {
    if (document.documentElement.classList.contains(SHOWN) || alreadyOffered() || waiting) return;
    if (!recommenderSeen && !document.getElementById('sz-btn')) return;
    if (!document.querySelector('[data-size-nudge]')) return;

    var deadline = Date.now() + WAIT_FOR_BUTTON_MS;
    waiting = true;

    (function attempt() {
      if (helpButton() && !alreadyOffered()) {
        waiting = false;
        rememberOffered();
        show();
        return;
      }

      if (Date.now() > deadline) {
        waiting = false;
        return;
      }

      window.setTimeout(attempt, 120);
    }());
  }

  function wire() {
    // On the document, not on the line, so the section replacing itself
    // underneath changes nothing.
    document.addEventListener('click', function(event) {
      var target = event.target;
      if (!target || !target.closest) return;

      if (target.closest('[data-size-nudge-close]')) {
        hide();
        return;
      }

      if (target.closest('[data-size-nudge-open]')) {
        hide();
        var button = document.getElementById('sz-btn');
        if (button) button.click();
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && document.documentElement.classList.contains(SHOWN)) hide();
    });

    document.addEventListener('change', function(event) {
      if (document.documentElement.classList.contains(SHOWN)) return;
      record(sizeFromChange(event.target));
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
}());
